import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './pages/page.component';
import { CartResolverService } from './cart-resolver.service';
import { UserResolverService } from './user-resolver.service';
import { UserOrdersResolverService } from './pages/profile/user-orders-resolver.service';
import { AuthGuardService } from './auth-guard.service';
import { StateResolverService } from './state-resolver.service';
import { authPath, cartPath, checkoutPath, profilePath } from 'app/constants/pages-constants';

const routes: Routes = [
  {
    path: '',
    component: PageComponent,
    data: {
      title: 'Menu'
    },
    resolve: {
      user: UserResolverService,
      cart: CartResolverService,
      currentAddress: StateResolverService
    },
    children: [
      {
        path: 'not-found',
        loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundModule)
      },
      {
        path: 'oops',
        loadChildren: () => import('./pages/oops/oops.module').then(m => m.OopsModule)
      },
      {
        path: 'main-page',
        loadChildren: () => import('./pages/main-page/main-page.module').then(m => m.MainPageModule),
      },
      {
        path: cartPath,
        loadChildren: () => import('./pages/cart/cart.module').then(m => m.CartModule),
        data: {
          title: 'Cart'
        },
      },
      {
        path: authPath,
        data: {
          title: 'Auth'
        },
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)
      },
      {
        path: profilePath,
        data: {
          title: 'Profile'
        },
        loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuardService],
      },
      {
        path: checkoutPath,
        data: {
          title: 'Checkout'
        },
        loadChildren: () => import('./pages/checkout/checkout.module').then(m => m.CheckoutModule),
        resolve: {
          orders: UserOrdersResolverService
        },
        canActivate: [AuthGuardService],
      },

      // TODO забрать нужную вёрстку, остальное удалить
      {
        path: 'address',
        loadChildren: () => import('./pages/address/address.module').then(m => m.AddressModule),
        data: {
          isHideHeader: true
        },
      },
      {
        path: 'delivery-address',
        loadChildren: () => import('./pages/delivery-address/delivery-address.module').then(m => m.DeliveryAddressModule),
        data: {
          isHideHeader: true
        },
      },
      {path: '**', redirectTo: 'main-page'}
    ]
  },
  {path: '**', redirectTo: 'geco'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
